import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_57.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter57.json";
import Head from "next/head";
export default function Chapter_57() {

  const router = useRouter()
    const location = useRouter();
    const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
     <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Gospel of Thomas unites Eastern and Western mysticism, teaching divine unity through reconciliation of opposites."
        ></meta>
        <meta
          property="og:title"
          content="Gospel of Thomas and the Divine Unity of All Beings"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="The Gospel of Thomas reveals profound insights on uniting opposites—inner and outer, male and female—into divine wholeness. Blending Eastern and Western mysticism, it reflects the Achintya Bheda Abheda philosophy of simultaneous unity and distinction with God. Through self-knowledge, spiritual vision, and practical exercises, seekers awaken to the luminous, transcendent reality pervading all existence."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=57"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=57"
        ></meta>
        <meta
          name="twitter:title"
          content="Gospel of Thomas and the Divine Unity of All Beings"
        ></meta>
        <meta
          name="twitter:description"
          content="Explore the Gospel of Thomas as a bridge between Eastern non-dualism and Western mysticism. Its sayings invite the reconciliation of all dualities, revealing the divine within and without. Rooted in Achintya Bheda Abheda philosophy, it offers both philosophy and practical vision exercises to perceive the eternal light body that interpenetrates and sustains all life."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=57" />
      </Head>
     <Common_html BlockData={BlockData} />
    </>
  );
}
